module.exports = __webpack_public_path__ + "img/consolas-light.172dd0dd.png";